import { createSelector } from 'reselect';

import { invoiceItemsSelectors as stdSliceSelectors } from './invoiceItemsSlice';

export { stdSliceSelectors };

// this can be used to validate item names are unique
export const uniqueLowercaseItemNames = createSelector(stdSliceSelectors.selectAll, (invoiceItems) => {
  return invoiceItems.reduce((lookup, item) => {
    if (item.name) {
      lookup.add(item.name.toLowerCase());
    }
    return lookup;
  }, new Set<string>());
});

// True when the user has at least one non-deleted global item (active or archived).
export const selectHasAnyGlobalItems = createSelector(stdSliceSelectors.selectAll, (invoiceItems) =>
  invoiceItems.some((item) => !item.isDeleted),
);
